import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
})
export class WelcomePage implements OnInit {
  constructor(
    private router: Router,
    private alertController: AlertController
  ) {}

  ngOnInit() {}

  navigateToLogin() {
    this.router.navigate(['login']);
  }

  async navigateToSignup() {
    /*const alert = await this.alertController.create({
      header: 'Cadastro inválido!',
      message:
        'É necessário ter um link de indicação válido para realizar seu cadastro.',
      buttons: ['OK'],
    });
    await alert.present();*/
    this.router.navigate(['/signup/JTIyY2hhcmxlc0Bjb2xhcHAuY29tLmJyJTIy']);
  }
}
